import React from 'react'
import { useSelector } from 'react-redux'
import useInput from '../hooks/input.hook'
import useFilter from '../hooks/filter.hook'

import Input from './UI/Input'
import Filter from './Filter'
import Amount from './UI/Amount'
import CardSelect from './CardSelect'

import * as filterSelectors from '../redux/selectors/filter.selectors'
import Select from './UI/Select'

const statusOption = [
    {value: 'WAIT', label: 'WAIT'},
    {value: 'CONFIRM', label: 'CONFIRM'}, 
    {value: 'REJECT', label: 'REJECT'}, 
    {value: null, label: 'All'}
]

const gatewayOption = [
    {value: 'iban', label: 'IBAN'},
    {value: 'acqnp', label: 'ACQ'}, 
    {value: 'p2p', label: 'P2P'}, 
    {value: null, label: 'All'}
]

function InvoiceFilter() {
    const { setInvoicesFilter } = useFilter()

    const filter = useSelector(filterSelectors.invoice)
    const id = useInput(filter.id, (value) => setInvoicesFilter({id: value}))
    const amount = { min: filter.amount.min, max: filter.amount.max }

    const filterOption = [
        { title: 'Status', elem: <Select option={statusOption} value={filter.status} handler={(option) => setInvoicesFilter({status: option.value})} placeholder="Status" /> },
        { title: 'Gateway', elem: <Select option={gatewayOption} value={filter.gateway} handler={(option) => setInvoicesFilter({gateway: option.value})} placeholder="Gateway" /> },
        { title: 'Card', elem: <CardSelect  value={filter.card} handler={(values) => setInvoicesFilter({card: values})} /> },
        { title: 'Amount', elem: <Amount handler={(value) => setInvoicesFilter({amount: value})} value={amount} /> }
    ]

    return (
        <>
            <Filter option={filterOption} />
            <Input input={id} placeholder='id' />
        </>
    )
}

export default InvoiceFilter